export enum RevisionStatus {
	NEED_REVISION = 'NEED_REVISION',
	REVISED = 'REVISED',
	RESCHEDULED = 'RESCHEDULED',
}
